<template>
  <div class="container-fluid">
    <span class="resize-loading" v-if="!shipmentEstimation">
      <span class="loader"></span>
    </span>
    <div v-if="shipmentEstimation" class="elite-tabs-wrapper">
      <tabs
        fill
        class="flex-column flex-md-row"
        tabNavWrapperClasses="nav-wrapper"
        tabNavClasses="nav elite-tabs"
        value="global"
      >
        <tab-pane title="global" id="1" :active="true">
          <span slot="title">
            <i class="ni ni-cloud-upload-96"></i>
            {{ $t("COMMON.GLOBAL") }}
          </span>
          <shipment-estimation-view-global :key="componentKey" 
          :shipmentEstimation="shipmentEstimation" 
          @onPickupCreated="pickupCreated"
          @onShipmentCreated="refreshData"
          @onCancelEstimation="cancelEstimation" />
        </tab-pane>
        <tab-pane title="pickup" id="2" v-if="shipmentEstimation.status == 'PICKUP'">
          <span slot="title">
            <i class="fas fa-truck"></i>
            Pickup
          </span>
          <div class="shipment-details px-5">
            <div
              class="widget-collapse mail-templates"
              v-for="shipment in shipments"
              :key="shipment.id"
            >
              <el-collapse accordion value="0">
                <el-collapse-item class="personnalization" :name="shipment.id">
                  <template slot="title">
                    <h3>{{ shipment.name || ('Shipment #' + shipment.id) }}</h3>
                  </template>

                  <div class="shipment-details px-5">
                    <view-shipment-component
                      :shipment="shipment"
          :key="componentKey"
                      @updated="refreshData($event)"
                    />
                  </div>
                </el-collapse-item>
              </el-collapse>
            </div>
        </div>
        </tab-pane>
      </tabs>
    </div>
  </div>
</template>

<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  Button,
  Collapse,
  CollapseItem
} from "element-ui";
import requestErrorMixin from "@/mixins/request-error-mixin";
import { Tabs, TabPane } from "@/components";
import ShipmentEstimationViewGlobal from "../partials/ShipmentEstimationViewGlobal.vue";
import {
  PICKUP_LOCATIONS,
} from "@/components/ElixioConnect/constants/shipment";
import ViewShipmentComponent from "@/components/ElixioConnect/Admin/ViewShipmentComponent";

export default {
  layout: "DashboardLayout",

  components: {
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    Tabs,
    TabPane,
    ShipmentEstimationViewGlobal,
    ViewShipmentComponent,
  },

  mixins: [requestErrorMixin],

  props: {
    shipmentEstimationId: {
      type: [String, Number],
      required: true,
    },
    isOpenPickupForm: {
      type: Boolean,
      default: false,
    }
  },

  data() {
    return {
      shipmentEstimation: null,
      pickupDefaults: {},
      pickupLocations: PICKUP_LOCATIONS,
      shipments: [],
      componentKey: 0,
    };
  },

  computed: {},

  watch: {},

  created() {
    this.get();
    if(this.isOpenPickupForm){
      this.packageDetails.packages.quantity = this.shipmentEstimation.shipments.length;
      const packages = this.packageDetails.packages || [];
      const totalWeight = packages.reduce(
        (sum, p) => sum + Number(p.weight || 0) * Number(this.shipmentEstimation.shipments.length),
        0
      );
      const totalQuantity = packages.reduce(
        (sum, p) => sum + Number(this.shipmentEstimation.shipments.length),
        0
      );
      this.pickupDefaults = {
        pickup_details: {
          date: {
            year: new Date().getFullYear(),
            month: new Date().getMonth() + 1,
            day: new Date().getDate(),
          },
          ready_at: { hour: 9, minute: 0 },
          ready_until: { hour: 17, minute: 0 },
          package_details: {
            weight: {
              unit: this.packageDetails.weight.unit,
              value: totalWeight.toString(),
            },
            quantity: totalQuantity.toString(),
          },
          pickup_location: this.pickupLocations,
          pickup_instructions: "",
        }
      };
    }
  },

  methods: {
    async get() {
      try {
        await this.$store.dispatch("elixioShipmentsEstimations/get", this.shipmentEstimationId);
        this.shipmentEstimation = this.$store.getters["elixioShipmentsEstimations/elixioShipmentsEstimation"];
        await this.viewEstimation(this.shipmentEstimation);
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },
    async viewEstimation(estimation){
      this.loading = true;
      
      try {
        const response = await this.$store.dispatch("properties/getShipmentsForPickup", {group_id: estimation.id});
        this.shipments = response.data.data;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        await this.showRequestError(error);
        console.log(error);
        this.$notify({
          type: "danger",
          message: this.  $t("ERRORS.SOMETHING_WENT_WRONG"),
        })
      }
    },
    refreshData(){
      this.componentKey++; 
    },
    pickupCreated(){
      this.$emit("onPickupSubmitted");
    },
    cancelEstimation(estimation){
      this.$emit("onCancelEstimation", estimation, true);
    }
  },
};
</script>
